var React = require('react');

function InfoIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"7","y":"3","width":"1","height":"1","fill":"white","key":0}),React.createElement("rect",{"x":"7","y":"6","width":"1","height":"6","fill":"white","key":1}),React.createElement("circle",{"cx":"7.5","cy":"7.5","r":"7","stroke":"white","key":2})]);
}

InfoIcon.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = InfoIcon;

InfoIcon.default = InfoIcon;
